module.exports = __webpack_public_path__ + "media/flags/mn-32f84418.svg";